import { useField } from 'react-final-form';

export const useHasPromotionAdded = (fieldName: string) => {
  const { input: bonusCashInput } = useField(`${fieldName}.bonusCash`, {
    subscription: { value: true }
  });

  const { input: freeBetInput } = useField(`${fieldName}.freeBet`, {
    subscription: { value: true }
  });

  const hasFreeBetApplied = Boolean(freeBetInput.value?.length);
  const hasBonusCashApplied = Boolean(bonusCashInput.value?.length);
  const hasPromotionAdded = hasFreeBetApplied || hasBonusCashApplied;
  return {
    hasPromotionAdded
  };
};
